export const ADDRESS_LINE_1_TESTID = 'address-line-1-testid';
export const ADDRESS_LINE_2_TESTID = 'address-line-2-testid';
export const ADDRESS_TOWN_TESTID = 'address-town-testid';
export const ADDRESS_POSTCODE_TESTID = 'address-postcode-testid';
export const ADDRESS_COUNTRY_TESTID = 'address-country-testid';

export const TELEPHONE_TESTID = 'telephone-testid';

export const ADD_OTHER_SOCIAL_MEDIA_INPUT_PREFIX_TESTID =
  'add-other-social-media-input-prefix-testid';
export const DELETE_OTHER_SOCIAL_MEDIA_INPUT_PREFIX_TESTID =
  'delete-other-social-media-input-prefix-testid';
export const ONLINE_STORE_WEBLINK_PREFIX_TESTID = 'online-store-weblink-prefix-testid';
export const PARTNER_SOURCE_TESTID = 'partner-source-testid';
export const PRODUCT_WEBLINK_PREFIX_TESTID = 'product-weblink-prefix-testid';

export const PRODUCT_CATEGORIES_GROUP_TESTID = 'product-categories-group-testid';

export const CERT_REQUIREMENTS_TESTID = 'cert-requirements-testid';

export const ATTACHMENT_UPLOADER_TESTID = 'attachment-uploader-attachments-testid';

export const ATTACHMENT_UPLOADER_ERROR_MESSAGE_TESTID = 'attachment-uploader-error-message-testid';
export const ATTACHMENT_UPLOADER_EXTERNAL_ERROR_MESSAGE_TESTID =
  'attachment-uploader-external-error-message-testid';

export const DELIVERY_AREAS_TEST_ID = 'delivery-areas-testid';

export const PIPELINE_PLANS_PROVIDED = 'pipeline-plans-provided-testid';
